/**
 * Minigame scene renderer
 */

import { getMinigameFactory } from '../../minigames'
import type { SceneData } from '../types'

export interface MinigameRendererContext {
  container: HTMLDivElement
  data: SceneData
  onComplete?: () => void
}

/**
 * Render minigame scene
 */
export function renderMinigame(context: MinigameRendererContext): HTMLElement {
  const { container, data, onComplete } = context

  const factory = getMinigameFactory(data.id)
  if (!factory) {
    if (onComplete) requestAnimationFrame(() => onComplete())
    return container
  }

  // Pass onComplete callback to minigame factory
  const handleComplete = () => {
    if (onComplete) {
      onComplete()
    }
  }

  const root = factory(container, handleComplete, data)
  container.appendChild(root)

  return container
}
